jQuery(document).ready ($) ->
	$features = $ '.features'
	unless $features.length > 0
		return


	for feature in $features
		$feature = $ feature
		$filtered = $feature.find '.feature:not(.concated)'
		$headings = $filtered.find '.heading, h3'
		minHeight = $headings.css 'min-height'
		heights = []

		for heading in $headings
			$heading = $ heading
			heights.push
				height: $heading.innerHeight()
				element: $heading

		maxHeight = Math.max.apply 0, heights.map (o) -> o.height

		if maxHeight > parseInt(minHeight)
			$headings.height maxHeight


/** WEBPACK FOOTER **
 ** ./assets/coffee/modules/features.coffee
 **/